import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "authConfig/authConfig";
import { msalInstance } from "msalInstance";
import { redirectToLogout } from "utils/redirectToLogout";

export const msalLogout = async () => {
  // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
  const accounts = msalInstance.getAllAccounts();
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API

  if (!activeAccount && accounts.length === 0) {
    /*
     * User is not signed in. Throw error or wait for user to login.
     * Do not attempt to log a user in outside of the context of MsalProvider
     */

    return null;
  }

  // Clears the session clock, local storage and any stale MSAL "in progress" flag, then logs out
  // without ever surfacing a refused redirect as an uncaught error (see redirectToLogout.js).
  await redirectToLogout(msalInstance);
};
